import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import isEqual from 'lodash.isequal';
import { PopoverTableForDomainPerformance } from '../../../pages/domain-summary/models/domain-summary.model';
import { DEFAULT_NAVIGATION_EXTRAS } from '../../common.constant';
import { AssessedStudentsPopoverItem } from '../../models/common.model';
import { getStaticLableClass } from '../../sharedUtils';
import {
  GROWTH_REPORT_PATHS,
  NoScoreDash,
} from './../../../../../src/app/multi-stage-growth-report/models/multi-stage-growth-report.model';

@Component({
  selector: 'app-popover-table',
  templateUrl: './popover-table.component.html',
  styleUrls: ['./popover-table.component.scss'],
})
export class PopoverTableComponent implements OnChanges {
  @Input() popoverTableData: PopoverTableForDomainPerformance = {};
  @Input() popoverHeaders: string[] = [];
  @Input() assessedStudentsPopoverList: AssessedStudentsPopoverItem[] = [];
  staticLableClass: string;
  students: AssessedStudentsPopoverItem[] = [];
  noScoreDash = NoScoreDash.DASH;

  constructor(private readonly router: Router, private readonly route: ActivatedRoute) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.assessedStudentsPopoverList &&
      !isEqual(changes.assessedStudentsPopoverList.currentValue, this.students)
    ) {
      this.students = this.assessedStudentsPopoverList;
    }
  }

  navigateToStudentReport(index: number): void {
    const studentId = index;
    this.router.navigate([`../${GROWTH_REPORT_PATHS.STUDENT_REPORT}`], {
      queryParams: { studentId },
      ...DEFAULT_NAVIGATION_EXTRAS,
      relativeTo: this.route,
    });
  }

  getStaticLableClass(): string {
    return getStaticLableClass(this.popoverTableData.placementLevelCodeId);
  }
}
